import React from "react"
import Relay from "react-relay"
import { Link, browserHistory } from "react-router"
import Icon from "../elements/Icon"
import LoadMoreLink from "../elements/LoadMoreLink"
import State from "../../stores/State"
import { usernameHack } from "../../scripts/utils"
import { FormattedMessage, FormattedHTMLMessage } from "react-intl"
import contributeMessages from "../../messages/profile"
import { messages as sharedMessages } from "../../messages/index"
import { getStyles, getStyleTag } from '../../styles/dynamicStyles'

class UserContributions extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      loadingMore: false
    }
  }

  render() {
    const viewer = this.props.viewer
    const resources = viewer.resources
      ? viewer.resources.edges.map(edge => edge.node)
      : []
    const hasNextPage =
      viewer.resources && viewer.resources.pageInfo.hasNextPage

    return (
      <div className="max-width-area">
        <div className="clearfix">
          <Link className="button pull-right" to="/contribute" style={getStyles('profile-form__button')}>
            <FormattedHTMLMessage {...contributeMessages.newContribution} />
          </Link>
          <h3>
            <FormattedMessage {...contributeMessages.myContributions} />
          </h3>
        </div>
        {resources.length > 0 && (
          <div className="item-list">
            {getStyleTag('item-list')}
            <ul>
              {resources.map((resource, i) => (
                <li key={i}>
                  <Link
                    to={this._editLink(resource)}
                    className="item-list__action"
                  >
                    <span className="item-list__action-text">
                      <FormattedMessage
                        id="button.edit"
                        defaultMessage="Edit"
                      />
                    </span>{" "}
                    <Icon icon="edit" />
                  </Link>
                  <span className="item-list__date">
                    {
                      "contributed_at" in JSON.parse(resource.custom_fields)
                        ? JSON.parse(resource.custom_fields).contributed_at.value
                        : ""
                    }
                  </span>
                  <Link to={"/item/" + resource.id} className="item-list__link">
                    {resource.title}
                  </Link>
                </li>
              ))}
            </ul>
            {hasNextPage && (
              <LoadMoreLink
                extraClasses="load-more--onwhite"
                onClick={this._handleLoadMore}
              >
                <FormattedMessage {...sharedMessages.loadMoreItems} />
              </LoadMoreLink>
            )}
          </div>
        )}
      </div>
    )
  }

  _editLink = resource => {
    return resource.type !== "article"
      ? "/edit-media/" + resource.id
      : "/item/" + resource.id + "?edit=1"
  }

  _clickResource = (resource, e) => {
    browserHistory.push("/item/" + resource.id)
  }

  _handleLoadMore = e => {
    e.preventDefault()
    this.props.relay.setVariables(
      {
        pageSize: this.props.relay.variables.pageSize + 20
      },
      readyState => {
        const loading = !readyState.done

        if (loading !== this.state.loading) {
          this.setState({
            loading: loading
          })
        }
      }
    )
  }

  componentDidMount() {
    this.props.relay.forceFetch({
      contributorId: State.get("userId")
    })
  }
}

export default Relay.createContainer(UserContributions, {
  initialVariables: {
    pageSize: 20,
    contributorId: State.get("userId")
  },

  prepareVariables: prevVariables => {
    const contributorId = prevVariables.contributorId
      ? usernameHack(prevVariables.contributorId)
      : "nobody."

    return {
      ...prevVariables,
      customFields: `{"contributor_id": "${contributorId}"}`
    }
  },

  fragments: {
    viewer: () => Relay.QL`
        fragment on Viewer {
            resources(
                first: $pageSize
                custom_fields: $customFields
                order: "date"
            )
            {
                total
                edges {
                    node {
                        id
                        title
                        custom_fields
                        type
                    }
                }
                pageInfo {
                        hasNextPage
                }
            }
        }`
  }
})



// WEBPACK FOOTER //
// ./webapp/components/modules/UserContributions.js